import { Star } from "lucide-react";

export default function GoogleReviewsBadge({ variant = "default" }) {
  const rating = 4.9;
  const reviewCount = 127;

  if (variant === "compact") {
    return (
      <div className="flex items-center gap-2 bg-white border border-gray-200 px-3 py-2 rounded-lg shadow-sm">
        <img 
          src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
          alt="Google" 
          className="h-4"
        />
        <div className="flex items-center gap-1">
          <span className="font-bold text-gray-800">{rating}</span>
          <div className="flex">
            {[1,2,3,4,5].map(i => (
              <Star key={i} className="w-3 h-3 text-yellow-400 fill-yellow-400" />
            ))}
          </div>
        </div>
        <span className="text-gray-500 text-xs">({reviewCount})</span>
      </div>
    );
  }

  return (
    <div 
      className="bg-white border border-gray-200 rounded-xl p-4 shadow-md inline-block"
      data-testid="google-reviews-badge"
    >
      <div className="flex items-center gap-3">
        <img 
          src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
          alt="Google" 
          className="h-6"
        />
        <div className="border-l border-gray-200 pl-3">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold text-gray-800">{rating}</span>
            <div className="flex">
              {[1,2,3,4,5].map(i => (
                <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
          </div>
          <p className="text-sm text-gray-500">{reviewCount} avis clients</p>
        </div>
      </div>
    </div>
  );
}
